/**
 * 创建于 2018/7/23
 * 作者: SHERlocked93
 * 功能: 事件总线
 */

import Vue from 'vue'

const EventBus = new Vue()

export default EventBus



// WEBPACK FOOTER //
// ./src/utils/eventBus.js